import { render, staticRenderFns } from "./ReceivedTable.vue?vue&type=template&id=0d81cab8&"
import script from "./ReceivedTable.vue?vue&type=script&lang=js&"
export * from "./ReceivedTable.vue?vue&type=script&lang=js&"
import style0 from "./ReceivedTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports